class CustomDropdown extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.isAccessibilityMode = false;

    // Setup elements
    this.labelEl = this.querySelector('[data-label]');
    this.priceEl = this.querySelector('[data-price]');
    this.toggle = this.querySelector('[data-toggle]');
    this.options = this.querySelectorAll('[data-option]');
    this.optionsWrap = this.querySelector('[data-options-wrap]');

    // Get options
    this.numberOfOptions = this.dataset.options;

    // Only initialize if there are more than one options
    if (this.numberOfOptions > 1) {
      // Bind event handlers
      this.toggle.addEventListener('click', this.handleToggle.bind(this));
      this.addEventListener('change', this.handleChange.bind(this));

      // Close the dropdown when clicking outside
      document.addEventListener('click', this.handleClickOutside.bind(this));

      // Listen for keyboard events
      this.addEventListener('keydown', this.handleKeydown.bind(this));

      // Close the dropdown when focus leaves the options
      this.optionsWrap.addEventListener('focusout', this.handleFocusOut.bind(this));

      // Set initial focus state
      this.manageFocus(false);
    }
  }

  handleKeydown(e) {
    if ((e.key === 'Escape' || e.key === 'Enter') && this.isOpen && this.isAccessibilityMode) {
      e.preventDefault();
      this.toggleOpen(false);
      this.toggle.focus();
    }
  }

  handleFocusOut(e) {
    if (this.isOpen && this.isAccessibilityMode && !e.currentTarget.matches(':focus-within')) {
      this.toggleOpen(false);
    }
  }

  handleClickOutside(e) {
    if (!this.contains(e.target)) {
      this.toggleOpen(false);
    }
  }

  handleChange(e) {
    if (!this.isAccessibilityMode) {
      this.toggleOpen(false);
    }

    const { label, price } = e.target.dataset;
    this.labelEl.innerHTML = label;
    this.priceEl.innerHTML = price;
  }

  handleToggle(e) {
    e.preventDefault();
    this.toggleOpen();
  }

  toggleOpen(open) {
    const newState = typeof open === 'boolean' ? open : !this.isOpen;
    this.classList.toggle('open', newState);
    this.isOpen = newState;
    this.manageFocus(newState);

    // Focus the first option using keyboard navigation
    if (newState && this.toggle.matches(':focus-visible')) {
      const option = this.optionsWrap.querySelector(':checked') || this.options[0];
      option.focus();
      this.isAccessibilityMode = true;
    }

    // Disable accessibility mode when dropdown is closed
    if (!newState) {
      this.isAccessibilityMode = false;
    }
  }

  manageFocus(enable) {
    this.options.forEach((el) => {
      el.tabIndex = enable ? 0 : -1;
    });
  }
}

customElements.define('custom-dropdown', CustomDropdown);
